import { render, staticRenderFns } from "./EpDangerLevelReportTo.vue?vue&type=template&id=836a6822&scoped=true&"
import script from "./EpDangerLevelReportTo.vue?vue&type=script&lang=js&"
export * from "./EpDangerLevelReportTo.vue?vue&type=script&lang=js&"
import style0 from "./EpDangerLevelReportTo.vue?vue&type=style&index=0&id=836a6822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836a6822",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('836a6822')) {
      api.createRecord('836a6822', component.options)
    } else {
      api.reload('836a6822', component.options)
    }
    module.hot.accept("./EpDangerLevelReportTo.vue?vue&type=template&id=836a6822&scoped=true&", function () {
      api.rerender('836a6822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/epreport/EpDangerLevelReportTo.vue"
export default component.exports